<template>
    <div>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-success shape-skew">
            </div>
            <div class="container shape-container pt-lg pb-300">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-7">
                        <h2 class="text-white display-1 pb-5 pb-sm-1">Filmes que Procuro</h2>
                        <p class="lead pb-4 text-white d-none d-sm-block">
                          Você também é um colecionador? Possui VHS com filmes gravados da TV? Estou procurando os títulos listados abaixo, caso possua alguma dublagem, entre em contato!
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <movie-card-deck classes="mt--400 pt-4" pagination procurados></movie-card-deck>
    </div>
</template>
<script>
import MovieCardDeck from "@/layout/components/Catalog/MovieCardDeck";

export default {
    components: {
        MovieCardDeck
    }
};
</script>
<style>
    h2.display-1 {
        line-height: 1;
    }
</style>
